module.exports = __webpack_public_path__ + "img/report1.a05a03d3.svg";